module.exports = __webpack_public_path__ + "static/media/4.35c1a537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/4.jpg
// module id = 422
// module chunks = 0